var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Observer from "../asset/observer";
import "jquery";
var ScreenSizeService = /** @class */ (function (_super) {
    __extends(ScreenSizeService, _super);
    function ScreenSizeService() {
        var _this = _super.call(this) || this;
        _this.updateMobile = function () {
            var width = window.top.document.documentElement.clientWidth;
            var mobile = width < 1025;
            if (mobile !== _this.mobile) {
                _this.mobile = mobile;
                setTimeout(function () {
                    _this.notify(mobile);
                });
            }
        };
        jQuery(window.top).on("resize", _this.updateMobile);
        _this.updateMobile();
        return _this;
    }
    return ScreenSizeService;
}(Observer));
export default new ScreenSizeService();



//////////////////
// WEBPACK FOOTER
// ./js/services/screenSize.service.ts
// module id = KEBJ
// module chunks = 1 2 3 4 5